<template>
  <transition name="fade">
    <div class="welfare" v-if="visible">
      <div class="welfare-shadow" @click="hideWelfarePopup"></div>
      <div class="welfare-main">
        <a href="javascript:;" class="main-close" @click="hideWelfarePopup"></a>
        <div class="main-banner"></div>
        <div class="main-title">
          <em class="main-title-ico left"></em>
          <p class="main-title-text">{{ letter.payWelfare }}</p>
          <em class="main-title-ico right"></em>
        </div>
        <ul class="main-list">
          <!-- 限时活动 临时处理：运营要求放第一个 -->
          <li class="main-list-item" v-if="showActivityEntry">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typepermanentactivity"></em>
              <p class="item-cont-text">{{ activityEntryText }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="activityBtn"
                @click="handleJumpLink"
              >
                <em
                  class="red-dot"
                  :class="{ active: showActivityRedDot }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <!-- 常驻活动入口 -->
          <li class="main-list-item" v-if="showPermanentActivityEntryTemp">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typepermanentactivitytemp"></em>
              <p class="item-cont-text">Dwarven Treasury's Generous Gifts</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="activityBtn"
                @click="jumpPermanentActivityLinkTemp"
              >
                <em
                  class="red-dot"
                  :class="{ active: showPermanentActivityRedDotTemp }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <li class="main-list-item" v-if="showPermanentActivityEntry">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typepermanentactivity"></em>
              <p class="item-cont-text">{{ permanentActivityEntryText }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="activityBtn"
                @click="jumpPermanentActivityLink"
              >
                <em
                  class="red-dot"
                  :class="{ active: showPermanentActivityRedDot }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <!-- 黑五入口 -->
          <li class="main-list-item" v-if="isBlackFridayStart">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typeblackfriday"></em>
              <p class="item-cont-text">{{ letter.blackFridayDiscount }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="vipBtn"
                @click="showBlackFridayPopup"
              >
                <em
                  class="red-dot"
                  :class="{ active: welfareBtnRecord.includes('vipBtn') }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <!-- 黑五入口end -->
          <li class="main-list-item" v-if="showVipBtn">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typestorevip"></em>
              <p class="item-cont-text">{{ letter.vipWeeklyWelfare }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="vipBtn"
                @click="vipBtnHandle"
              >
                <em
                  class="red-dot"
                  :class="{ active: welfareBtnRecord.includes('vipBtn') }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <!-- 新增迁移所有按钮 start  todo设置好每个按钮 -->
          <li class="main-list-item" v-if="showShareBtn">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typeshare"></em>
              <p class="item-cont-text">{{ letter.shareGift }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="shareBtn"
                @click="shareBtnHandle"
              >
                <em
                  class="red-dot"
                  :class="{ active: welfareBtnRecord.includes('shareBtn') }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <li class="main-list-item" v-if="showCouponBtn">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typecoupon"></em>
              <p class="item-cont-text">{{ letter.couponMyQuan }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="couponBtn"
                @click="showCoupon"
              >
                <em
                  class="red-dot"
                  :class="{ active: welfareBtnRecord.includes('couponBtn') }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <li class="main-list-item" v-if="showWalletBtn">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typezbit"></em>
              <p class="item-cont-text">{{ getCoinsName }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="walletBtn"
                @click="walletBtnHandle"
              >
                <em
                  class="red-dot"
                  :class="{ active: welfareBtnRecord.includes('walletBtn') }"
                ></em>
                {{ letter.go }}
              </a>
            </div>
          </li>
          <!-- 新增迁移所有按钮 end -->
          <!-- 新增大会员中心入口 -->
          <li class="main-list-item" v-if="showRightsCenter">
            <div class="item-bg"></div>
            <div class="item-cont">
              <em class="item-cont-ico ico-typerightscenter"></em>
              <p class="item-cont-text">{{ letter.rightsCenterBtn }}</p>
              <a
                href="javascript:;"
                class="item-cont-btn"
                data-record="rightsCenterBtn"
                @click="jumpRightsCenter"
              >
                <em
                  class="red-dot"
                  :class="{ active: showRightsCenterRedDot }"
                ></em>
                {{ letter.knowMore }}
              </a>
            </div>
          </li>
          <!-- 新增大会员中心入口 -->
        </ul>
      </div>
      <transition name="fade">
        <coupon-list-popup
          v-if="isShowGameCouponPopup"
          popupType="game"
          :enableCouponList="gameCouponEnableList"
          :disableCouponList="gameCouponDisableList"
          :expireCouponList="gameCouponExpireList"
          :activeId="gameActiveCouponId"
          :showItemUseBtn="isShowGameItemUseBtn"
          @closeCouponPopup="hideGameCouponPopup"
        ></coupon-list-popup>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import CouponListPopup from '@components/officialStore/coupon/CouponListPopup.vue';
import {
  DELETE_WELFARE_RECORD,
  SET_VISIBLE_BLACK_FRIDAY_POPUP
} from '@store/officialStore/index';
import showWelfare from '@mixins/officialStore/showWelfare';
import coupon from '@mixins/officialStore/coupon';
import login from '@mixins/officialStore/login';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGameLanguage } from '@store/officialStore/gameConf';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
import openActivity, { EVENT_LIST_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  name: 'WelfarePopup',
  mixins: [coupon, showWelfare, login],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPermanentActivityRedDot: true,
      showPermanentActivityRedDotTemp: true,
      showRightsCenterRedDot: true,
      showActivityRedDot: true
    };
  },
  computed: {
    ...mapState({
      welfareBtnRecord: state => state.welfareBtnRecord,
      letter: state => state.letter,
      lang: state => state.lang,
      isUidLogin: state => state.login.isUidLogin,
      isLogin: state => state.login.isLogin,
      isBlackFridayStart: state => state.isBlackFridayStart
    }),
    ...mapGetters(['gameInfoConfig', 'getCoinsName']),
    showPermanentActivityEntryTemp() {
      // 常驻累储活动统一处理展示逻辑
      const currentUTCTime = new Date().toISOString();
      // 常驻累储活动结束时间
      const targetTimeMaps = {
        285: {
          startTime: '2025-07-24T23:59:59Z',
          endTime: '2025-08-07T23:59:59Z'
        }
      };
      if (targetTimeMaps.hasOwnProperty(+this.gameId)) {
        // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
        return (
          targetTimeMaps[+this.gameId]?.startTime < currentUTCTime &&
          currentUTCTime < targetTimeMaps[+this.gameId]?.endTime
        );
      } else {
        return false;
      }
    },
    showPermanentActivityEntry() {
      // 常驻累储活动统一处理展示逻辑
      const currentUTCTime = new Date().toISOString();
      // 常驻累储活动结束时间
      const targetTimeMaps = {
        285: '2028-12-31T23:59:59Z'
      };
      if (targetTimeMaps.hasOwnProperty(+this.gameId)) {
        // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
        return currentUTCTime < targetTimeMaps[+this.gameId];
      } else {
        return false;
      }
    },
    permanentActivityEntryText() {
      if (+this.gameId === 285) {
        return 'Top-up Reward!';
      }
      return getGameLanguage(this.lang, 'activityEntryTimeLimit', this.gameId);
    },
    showActivityEntry() {
      // 限时活动统一处理展示逻辑
      const currentUTCTime = new Date().toISOString();
      // 限时活动结束时间
      const targetTimeMaps = {
        263: '2025-07-18T23:59:59Z',
        285: '2025-09-03T23:59:59Z',
        191: '2025-02-20T23:59:59Z'
      };
      if (targetTimeMaps.hasOwnProperty(+this.gameId)) {
        // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
        return currentUTCTime < targetTimeMaps[+this.gameId];
      } else {
        return false;
      }
    },
    activityEntryText() {
      if (+this.gameId === 285) {
        return "Khaos's Treasure";
      }
      if (+this.gameId === 263) {
        return 'Team up for gifts';
      }
      if (+this.gameId === 191) {
        // 限时活动定制化名称
        return 'Space Labyrinth';
      }
      // 限时活动通用名称
      return getGameLanguage(this.lang, 'activityEntryTimeLimit', this.gameId);
    }
  },
  methods: {
    ...mapMutations({
      deleteWelfareRecord: DELETE_WELFARE_RECORD,
      setVisibleBlackFridatPopup: SET_VISIBLE_BLACK_FRIDAY_POPUP
    }),
    jumpToLinkPage(link) {
      openActivity(EVENT_LIST_ACTIVITY, link);
    },
    hideWelfarePopup() {
      this.$emit('update:visible', false);
    },
    vipBtnHandle(e) {
      this.deleteWelfareRecord(e.target.dataset.record);
      this.hideWelfarePopup();
      this.$router.push({ name: 'vipScore' });
    },
    shareBtnHandle(e) {
      this.deleteWelfareRecord(e.target.dataset.record);
      this.hideWelfarePopup();
      if (!this.showShareBtn) {
        return;
      }
      const preUrl =
        process.env.NODE_ENV === 'production'
          ? `pay.${globalConfig.getMainHost()}/platform`
          : `gabres-test.${globalConfig.getMainHost()}`;
      const jumpPage = `//${preUrl}/officialStore.html#/share_event`;
      clickButton({
        btnName: 'go_link',
        locationKey: locationType.eventList,
        otherParams: {
          link: jumpPage,
          name: 'sharePage'
        }
      });
      openActivity(
        EVENT_LIST_ACTIVITY,
        jumpPage,
        {
          gameId: this.gameId,
          fromStoreCid: globalConfig.getHrefParam('cid'),
          fromStoreScid: globalConfig.getHrefParam('scid'),
          language: this.lang || 'en-US',
          ...getGlobalGetLinkParams()
        },
        {
          target: '_self'
        }
      );
    },
    jumpPermanentActivityLink() {
      if (!this.showPermanentActivityEntry) {
        return;
      }
      this.showPermanentActivityRedDot = false;
      const linkMaps = {
        285: `//auto-page.${globalConfig.getMainHost()}/k1longtermtopup/`
      };
      if (linkMaps.hasOwnProperty(+this.gameId)) {
        openActivity(EVENT_LIST_ACTIVITY, linkMaps[+this.gameId], {
          language: this.lang,
          ...getGlobalGetLinkParams()
        });
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: linkMaps[+this.gameId],
            name: 'activityPage'
          }
        });
      }
    },
    jumpPermanentActivityLinkTemp() {
      if (!this.showPermanentActivityEntryTemp) {
        return;
      }
      this.showPermanentActivityRedDotTemp = false;
      const linkMaps = {
        285: `//auto-page.${globalConfig.getMainHost()}/k1_Jul25opscamp/`
      };
      if (linkMaps.hasOwnProperty(+this.gameId)) {
        openActivity(EVENT_LIST_ACTIVITY, linkMaps[+this.gameId], {
          language: this.lang,
          ...getGlobalGetLinkParams()
        });
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: linkMaps[+this.gameId],
            name: 'activityPage'
          }
        });
      }
    },
    handleJumpLink() {
      // return false;
      //临时注释 添加banner打开
      if (!this.showActivityEntry) {
        return;
      }
      this.showActivityRedDot = false;
      const linkMaps = {
        191: `//auto-page.${globalConfig.getMainHost()}/pnszd03/`,
        263: `//auto-page.${globalConfig.getMainHost()}/mycb02/`,
        285: `//auto-page.${globalConfig.getMainHost()}/k1_Augopscamp/`
      };
      if (linkMaps.hasOwnProperty(+this.gameId)) {
        openActivity(EVENT_LIST_ACTIVITY, linkMaps[+this.gameId], {
          language: this.lang,
          ...getGlobalGetLinkParams()
        });
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: linkMaps[+this.gameId],
            name: 'activityPage'
          }
        });
      }
    },
    jumpRightsCenter() {
      this.showRightsCenterRedDot = false;
      if (this.gameInfoConfig?.rightsCenterLink) {
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: this.gameInfoConfig?.rightsCenterLink,
            name: 'activityPage'
          }
        });
        openActivity(
          EVENT_LIST_ACTIVITY,
          this.gameInfoConfig?.rightsCenterLink,
          {
            language: this.lang,
            appLanguage: this.lang,
            ...getGlobalGetLinkParams()
          }
        );
      }
    },
    couponBtnHandle(e) {
      this.deleteWelfareRecord(e.target.dataset.record);
    },
    walletBtnHandle(e) {
      this.deleteWelfareRecord(e.target.dataset.record);
      this.$router.push({ name: 'wallet' });
    },
    showCoupon(e) {
      this.showGameCouponPopup();
      this.deleteWelfareRecord(e.target.dataset.record);
    },
    showBlackFridayPopup(e) {
      if (!this.isLogin || this.isUidLogin) {
        this.login();
        return;
      }
      this.deleteWelfareRecord(e.target.dataset.record);
      this.hideWelfarePopup();
      this.setVisibleBlackFridatPopup(true);
    }
  },
  components: {
    CouponListPopup
  }
};
</script>

<style lang="scss" scoped>
.welfare {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('pay-welfare-bg.png');
  }

  .main {
    &-close {
      position: absolute;
      right: 46px;
      top: 36px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
    &-banner {
      margin: 22px auto 0;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('pay-welfare-banner.png');
    }
    &-title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -52px;
      margin-bottom: 20px;
      &-ico {
        display: inline-block;
        width: 108px;
        height: 2px;
        background-color: #ffffff;
      }
      &-text {
        margin: 0 36px;
        font-size: 48px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    &-list {
      overflow: scroll;
      height: 550px;

      &-item {
        position: relative;
        margin-bottom: 20px;
      }
      .item {
        &-bg {
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          @psetbg ('welfare-item-bg.png',false);
        }
        &-cont {
          position: absolute;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          top: 50%;
          left: 50%;
          width: 614px;
          transform: translate(-50%, -50%);
          &-ico {
            width: 140px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
          &-text {
            width: 280px;
            font-size: 30px;
            text-align: left;
            color: #ffffff;
          }
          &-btn {
            position: relative;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            font-size: 23px;
            text-shadow: 1px 1px 4px #000;
            line-height: 41px;
            color: #ffffff;
            @psetbg ('welfare-btn-bg.png');
            .red-dot {
              display: none;
              position: absolute;
              top: -6px;
              left: -6px;
              width: 16px;
              height: 16px;
              background-color: #ff2800;
              border-radius: 50%;
              &.active {
                display: block;
              }
            }
          }
        }
      }
    }
    /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
    &-list::-webkit-scrollbar {
      display: none;
    }
    /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
    &-list {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
  }
}

// 新增迁移所有按钮 start
.ico-typestorevip {
  display: inline-block;
  @psetbg ('welfare-storevip.png');
}
.ico-typeshare {
  display: inline-block;
  @psetbg ('welfare-share.png');
}
.ico-typezbit {
  display: inline-block;
  @psetbg ('welfare-zbit.png');
}
.ico-typecoupon {
  display: inline-block;
  @psetbg ('welfare-coupon.png');
}
.ico-typeblackfriday {
  display: inline-block;
  @psetbg ('welfare-blackfriday.png');
}
.ico-typerightscenter {
  display: inline-block;
  @psetbg ('welfare-storevip.png');
}
// 新增迁移所有按钮 send

.ico-typepermanentactivity {
  display: inline-block;
  @psetbg ('welfare-permanentactivity.png');
}
.ico-typepermanentactivitytemp {
  display: inline-block;
  background: url('../../assets/image/officialStore/dtmslg/welfare-permanentactivitytemp.png');
  width: 140px;
  height: 110px;
}
.ico-type-activity2 {
  display: inline-block;
  background: url('../../assets/image/officialStore/ztmslg/activity_ico2.png');
  width: 89px;
  height: 80px;
}
.ico-type-activity3 {
  display: inline-block;
  @psetbg ('activity_ico3.png');
}
</style>
